import { Text, BlockStack, SkeletonBodyText } from "@medentic/polaris-react";
import TagsList from "./TagsList";
import { useTranslation } from "react-i18next";

type TagContext = "patients" | "attendees";

interface TagsCardProps {
  selectedTags: string[];
  onTagsUpdate: (tags: string[]) => void;
  loading: boolean;
  hccId?: string;
  context?: TagContext;
}

function TagsCard({
  selectedTags,
  onTagsUpdate,
  loading,
  hccId,
  context = "patients",
}: TagsCardProps) {
  const { t } = useTranslation();

  if (loading) {
    return <SkeletonBodyText lines={2} />;
  }

  return (
    <BlockStack gap="400">
      <Text variant="headingMd" as="h2">
        {t("patientDetails.tagsTitle")}
      </Text>
      <TagsList
        selectedTags={selectedTags}
        onTagsUpdate={onTagsUpdate}
        hccId={hccId}
        context={context}
      />
    </BlockStack>
  );
}

export default TagsCard;
